import React, { useEffect, useState } from 'react';
import { fetchBillingStatus } from './billingApi';
import './TrialBanner.css';

function daysUntil(dateString) {
  if (!dateString) return null;
  const target = new Date(dateString);
  if (Number.isNaN(target.getTime())) return null;
  const diffMs = target.getTime() - Date.now();
  return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
}

// Persistent top-of-page banner: "you're on a free Pro trial, full access,
// N days left." Requested by Alejo 2026-08-09 -- the reverse-trial data
// (trial_active/trial_expires_at) already existed in /billing/status, it was
// just never surfaced anywhere the merchant would actually see it day to day
// (it was buried in Settings' BillingStatusWidget).
//
// FAIL-SAFE by design: any error, missing session, or trial_active !== true
// renders nothing. This is purely informational -- it must never block or
// error the page it sits on top of.
export default function TrialBanner({ token }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!token) return undefined;
    fetchBillingStatus({ token })
      .then((data) => { if (!cancelled) setStatus(data); })
      .catch(() => {}); // fail-safe: no banner, no error surfaced
    return () => { cancelled = true; };
  }, [token]);

  if (!status || status.trial_active !== true) return null;

  const daysLeft = daysUntil(status.trial_ends_at);
  if (daysLeft === null || daysLeft <= 0) return null;

  return (
    <div className="rf-trial-banner" role="status">
      <span className="material-symbols-outlined rf-trial-banner-icon">stars</span>
      <span className="rf-trial-banner-text">
        You're on a free Pro trial — full access to every feature.{' '}
        <strong>{daysLeft} day{daysLeft === 1 ? '' : 's'} left.</strong>
      </span>
    </div>
  );
}
